import { Link } from "gatsby"
import * as styles from "@/styles/modules/DropdownNav.module.scss"

export default function DropdownNavItem({ itemText, emoji, title, url }) {
  // Must be internal links
  return (
    <Link
      to={url}
      className={styles.item}
      title={title}
      activeClassName={styles.active}
    >
      {emoji && <span className={styles.emoji}>{emoji}</span>}
      {itemText}
    </Link>
  )
}
